import React, {useState, useEffect} from 'react';
import { Form } from 'react-final-form';
import { useParams } from 'react-router-dom'
import { Row, Col, ButtonToolbar, Button } from 'reactstrap';
import formValidation from "@/shared/validation/adduser";
import axios from 'axios';
import {patch4Select, unpatchSelect, labelizeNamedData} from '@/shared/helpers'
import { fetchUser, fetchRoles } from "@/shared/apiHelper"
import FormFields from '../../components/FormFields'
import {useDispatch, sendFlashMessage} from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/ApiErrorMessage"
import { isObject } from '../../../../shared/helpers';

const patchRole4Select = (user) => {
    if (user.roles.length > 0) {
        let tmp = Object.values(user.roles).filter(key => key.name === 'Admin' || key.name === 'Super Admin');

        if (tmp.length > 0) {
            user.role_id = {
                value: tmp[0].id,
                label: tmp[0].name
            };
        } else {
            user.role_id = {
                value: '',
                label: 'No Role Assigned'
            };
        }
    } else {
        user.role_id = {
            value: '',
            label: 'No Roles Available'
        };
    }
    return user;
}

const formatDate = (month, day) => {
  let year = String(1).padStart(4, '0');
  month = String(month).padStart(2, '0');
  day = String(day).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const getBirthday = (user) => {
    if(user.dob){
        let dateParts = user.dob.split('-');
        let month = dateParts[1];
        let day = dateParts[2];
        user.month = month;
        user.day = day;
    }
    return user;
}

const setBirthday = (values) => {
    if(values.day && values.month){
        let month = isObject(values.month)? values.month.value : values.month
        let day = isObject(values.day)? values.day.value : values.day
        values.dob = formatDate(month, day)
    }
    return values;
}

const EditUserForm = ({organization}) => {
    const dispatch = useDispatch()
    let config = {
        roleInput: 'select',
        roleField: 'role_id',
        roleDisable: false
    }
    let { id } = useParams();

    const [loading, setLoading] = useState(true)
    const [roles, setRoles] = useState(null)
    let [user, setUser] = useState(null)

    useEffect( () => {
        if(organization)    {
            fetchUser(organization.id, id)
            .then( data => {
                data.avatar = null;
                setUser(data);
                setLoading(false)
            })
        }
    }, [organization])

    useEffect( () => {
        if(organization)    {
            getRoles(organization)
        }
    }, [organization])

    const getRoles = ( organization ) => {
        setLoading(true)
        fetchRoles( organization.id, false )
        .then( data => {
            let newData = labelizeNamedData(data);
            // console.log(newData)
            setRoles(newData);
            setLoading(false)
        })
    }
    
    const onSubmit = values => {
        // console.log('cccccccccccccccc')
        // console.log(parseInt(values.country_id.value, 10))
        // console.log(values.country_id)
        if(!config.roleDisable && values.role_id) {
            if (values.role_id?.value) {
                values.roles = [values.role_id.value]
            } else {
              delete(values["roles"]);
            }
        }   else    {
            delete(values["roles"]);
        }
        delete(values["role_id"]);
        values = setBirthday(values)   
        const isLocked = values.is_locked ? 1 : 0;
        const lockReason = isLocked ? values.is_locked_reason : null;     
        let userData = {
            first_name: values.first_name,
            last_name: values.last_name,
            roles: values.roles,
            user_status_id: values.user_status_id?.value || values.user_status_id,
            email: values.email,
            phone: values.phone || null,
            country_id: values.country_id.value,
            // award_level managed via program-specific edit (requires use_award_levels context)
            work_anniversary: values.work_anniversary,
            dob: values.dob,
            division: values.division,
            employee_number: values.employee_number,
            supervisor_employee_number: values.supervisor_employee_number,
            password: values.password,
            password_confirmation: values.password_confirmation,
            is_locked: isLocked,
            is_locked_reason: lockReason,
            force_password_reset: values.force_password_reset ? 1 : 0,
        }
        axios.put(`/organization/${organization.id}/user/${user.id}`, userData)
        .then( (res) => {
            if(res.status == 200)  {
                window.location = `/users/view/${user.id}?message=User saved successfully`
            }
        })
        .catch( error => {
            dispatch(sendFlashMessage(<ApiErrorMessage errors={error.response.data} />, 'alert-danger'))
            setLoading(false)
        })
    }
    
    const onClickCancel = () => {
        window.location = `/users/view/${user.id}`
    }

    if( !roles || !user || !organization?.id) return 'Loading...'

    user = patchRole4Select(user)
    user = getBirthday(user)
    user.user_status_id = String(user.user_status_id ? user.user_status_id : "")
    config = {...config, ...{roles}}
    return (
    <Form
        onSubmit={onSubmit}
        validate={(values) => formValidation.validateForm(unpatchSelect(values, ["role_id"]))}
        initialValues={user}
    >
    {({ handleSubmit, form, submitting, pristine, values }) => (
    <form className="form" onSubmit={handleSubmit}>
        <Row className='w100'>
            <Col md="6" lg="6" xl="6">
                <h3 className="mb-4">User Profile</h3>
            </Col>
            <Col md="6" lg="6" xl="6" className='text-right'>
                <ButtonToolbar className="modal__footer flex justify-content-right w100">
                    <Button outline color="primary" className="mr-3" onClick={onClickCancel}>Cancel</Button>{' '}
                    <Button type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">Save</Button>
                </ButtonToolbar>
            </Col>
        </Row>
        <FormFields config={config} form={form} submitting={submitting} pristine={pristine} values={values}/>
    </form>
    )}
  </Form>
)}
export default EditUserForm;
